import {
    Component, ElementRef, Renderer2, Output, EventEmitter, forwardRef, Input, AfterContentInit, AfterViewChecked
} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {CheckboxItemComponent} from "./checkbox.item.component";

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxButtonComponent),
    multi: true
};

const noop = ()=> {
};

@Component({
    selector: 'checkbox-button',
    template: require('./checkbox.button.template.html'),
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class CheckboxButtonComponent implements ControlValueAccessor, AfterContentInit, AfterViewChecked {

    constructor(private el: ElementRef,
                private renderer: Renderer2) {
    }

    @Output()
    onChange: EventEmitter<any> = new EventEmitter();

    //The internal data model
    _innerValue: any = [];
    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;

    writeValue(obj: any): void {
        if (obj !== this.innerValue) {
            this.innerValue = obj;
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChange.subscribe(fn);
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    //get accessor
    get innerValue(): any {
        return this._innerValue;
    };

    ngAfterViewChecked() {
        this.checkboxes.forEach((item: CheckboxItemComponent)=> {
            if (this.autoWidth) {
                item.setWidth(100 / this.checkboxes.length + '%');
            }
            item.updateView();
        });
    }

    //set accessor including call the onchange callback
    set innerValue(v: any) {
        if (v !== this._innerValue) {
            if (!this._innerValue) {
                this._innerValue = [];
            }

            if (v && !v.shouldRemove) {
                this._innerValue.push(v);
            } else {
                this._innerValue = this._innerValue.filter((value)=> {
                    return value !== v.value;
                });
                if (this._innerValue.length == 0) {
                    this._innerValue = null;
                }
            }
            this.onChange.emit(this._innerValue);
        }
    }

    private checkboxes: Array < CheckboxItemComponent > = [];

    @Input()
    autoWidth: boolean;

    registerComponent(checkbox: CheckboxItemComponent) {
        this.checkboxes.push(checkbox);
    }

    selectItem(checkbox: CheckboxItemComponent) {
        checkbox.toggle();
        if (checkbox.getIsActive()) {
            this.writeValue(checkbox.getValue());
        } else {
            this.writeValue({value: checkbox.getValue(), shouldRemove: true});
        }
    }

    ngAfterContentInit() {
        this.renderer.addClass(this.el.nativeElement, 'btn-group');
        this.renderer.setStyle(this.el.nativeElement, 'width', '100%');
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/checkbox/checkbox.button.component.ts